"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _i18n = _interopRequireDefault(require("../@i18n"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _reactInputMask = _interopRequireDefault(require("react-input-mask"));
var _reactCurrencyFormat = _interopRequireDefault(require("react-currency-format"));
var _excluded = ["label", "value", "onChange", "onEnterPress", "type", "mode", "containerStyle", "inputStyle", "labelStyle", "leftIcon", "rightIcon", "leftIconClick", "rightIconClick", "message", "mask", "maskPlaceholder", "alwaysShowMask", "beforeMaskedStateChange", "maxLength", "multiline", "prefix", "suffix", "disabled", "decimalScale"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Input = function Input(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange,
    onEnterPress = _ref.onEnterPress,
    type = _ref.type,
    mode = _ref.mode,
    containerStyle = _ref.containerStyle,
    inputStyle = _ref.inputStyle,
    labelStyle = _ref.labelStyle,
    leftIcon = _ref.leftIcon,
    rightIcon = _ref.rightIcon,
    leftIconClick = _ref.leftIconClick,
    rightIconClick = _ref.rightIconClick,
    message = _ref.message,
    mask = _ref.mask,
    maskPlaceholder = _ref.maskPlaceholder,
    alwaysShowMask = _ref.alwaysShowMask,
    beforeMaskedStateChange = _ref.beforeMaskedStateChange,
    maxLength = _ref.maxLength,
    multiline = _ref.multiline,
    _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? 'R$ ' : _ref$prefix,
    suffix = _ref.suffix,
    disabled = _ref.disabled,
    _ref$decimalScale = _ref.decimalScale,
    decimalScale = _ref$decimalScale === void 0 ? 2 : _ref$decimalScale,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    fileName = _useState2[0],
    setFileName = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    fileMessageId = _useState4[0],
    setFileMessageId = _useState4[1];
  var finalLabel = (0, _i18n["default"])(label) || label;
  (0, _react.useEffect)(function () {
    setFileMessageId('file-message-' + parseInt(Math.random() * 10000) + '-' + new Date().getTime());
  }, []);
  (0, _react.useEffect)(function () {
    if (type !== 'file') return;
    var fileMessage = document.getElementById(fileMessageId);
    if (!fileMessage) return;
    if (!value) {
      setFileName('Clique para escolher');
      // fileMessage.innerHTML = 'Clique para escolher';
      if (rest.id) {
        document.getElementById(rest.id).value = [];
        document.getElementById(rest.id).value = '';
      }
    } else {
      setFileName(value.name);
      // fileMessage.innerHTML = value.name;
    }
  }, [value]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-control-input ".concat(mode, " \n\t\t\t\t\t\ttype-").concat(type, "\n\t\t\t\t\t\t\t").concat(type === 'file' ? 'file-type' : '', " \n\t\t\t\t\t\t\t").concat(multiline ? 'multiline' : '', "\n\t\t\t\t\t\t\t").concat(leftIcon ? 'has-left-icon' : '', " \n\t\t\t\t\t\t\t").concat(rightIcon ? 'has-right-icon' : ''),
    style: containerStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content"
  }, !!leftIcon && /*#__PURE__*/_react["default"].createElement("div", {
    className: "left-icon icon",
    onClick: leftIconClick
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: leftIcon
  })), type === 'file' && /*#__PURE__*/_react["default"].createElement("div", {
    className: "file"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: 'faFilePdf'
  }), /*#__PURE__*/_react["default"].createElement("span", {
    id: fileMessageId
  }, "Clique para escolher")), !!mask && /*#__PURE__*/_react["default"].createElement(_reactInputMask["default"], (0, _extends2["default"])({}, rest, {
    mask: mask,
    maskPlaceholder: maskPlaceholder,
    alwaysShowMask: alwaysShowMask,
    beforeMaskedStateChange: beforeMaskedStateChange,
    value: value,
    onChange: _onChange,
    placeholder: " ",
    style: inputStyle,
    maxLength: maxLength,
    disabled: disabled
  })), type === 'formatted-number' && /*#__PURE__*/_react["default"].createElement(_reactCurrencyFormat["default"], (0, _extends2["default"])({}, rest, {
    value: value,
    displayType: 'input',
    thousandSeparator: '.',
    decimalSeparator: ',',
    style: inputStyle,
    decimalScale: decimalScale,
    fixedDecimalScale: true,
    placeholder: " ",
    prefix: prefix,
    suffix: suffix,
    allowNegative: false,
    disabled: disabled,
    onValueChange: function onValueChange(values) {
      //('values', values)
      var formattedValue = values.formattedValue,
        value = values.value,
        floatValue = values.floatValue;
      _onChange({
        target: {
          value: formattedValue,
          formattedValue: formattedValue,
          numberValue: value,
          floatValue: floatValue
        }
      });
    }
  })), !mask && !multiline && type !== 'formatted-number' && /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, rest, {
    value: type === 'file' ? undefined : value,
    onChange: function onChange(e) {
      if (type == 'file') {
        if (!e.target.files.length) {
          // fileMessageRef.current.innerHTML = 'Clique para escolher';
          setFileName('Clique para escolher.');
          if (rest.id) {
            document.getElementById(rest.id).value = [];
            document.getElementById(rest.id).value = '';
          }
        } else {
          // fileMessageRef.current.innerHTML = e.target.files[0].name;
          setFileName(e.target.files[0].name);
        }
      }
      if (_onChange) _onChange(e);
    },
    placeholder: " ",
    style: inputStyle,
    type: type,
    maxLength: maxLength,
    disabled: disabled,
    onKeyPress: function onKeyPress(e) {
      var code = e.key || e.code || e.keyCode || e.which || e.charCode;
      if (code == 13 || code === 'Enter') {
        if (typeof onEnterPress === 'function') onEnterPress(e);
      }
    }
  })), multiline && /*#__PURE__*/_react["default"].createElement("textarea", (0, _extends2["default"])({}, rest, {
    disabled: disabled,
    placeholder: " ",
    style: inputStyle,
    value: value,
    onChange: _onChange
  })), /*#__PURE__*/_react["default"].createElement("label", {
    style: labelStyle
  }, finalLabel), !!rightIcon && /*#__PURE__*/_react["default"].createElement("div", {
    className: "right-icon icon",
    onClick: rightIconClick
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: rightIcon
  }))), !!message && /*#__PURE__*/_react["default"].createElement("div", {
    className: "message"
  }, message));
};
var _default = Input;
exports["default"] = _default;